/** @format */

import { isErrorResponse, getBooking } from '../../api/api';
import { action, thunk } from 'easy-peasy';

const resultModel = {
	error: null,
	Booking: null,

	fetchBooking: thunk(async (actions, guid) => {
		const res = await getBooking(guid);
		if (isErrorResponse(res)) {
			actions.setError(res);
		} else {
			actions.setBooking(res);
		}
	}),
	setError: action((state, error) => {
		state.error = error;
	}),
	setBooking: action((state, result) => {
		result.title = result.travelOut.stopIdDepartureName + ' - ' + result.travelOut.stopIdArrivalName;

		state.Booking = result;
	}),
	reset: action((state) => {
		state.error = null;
		state.Booking = null;
	}),
};

export default resultModel;
